export default __webpack_public_path__ + "static/invoice-custom-c827fa96b076f38728d2f5b767044962.jpg";